export default "__VITE_ASSET__KofYEjVi__"